module.exports = {
  data: null,
  share_data: null
};